import './vendor/tenup-accordion';
import './components/menu-toggle';
import './components/anchor';
import './components/faq-toggles';
